<template>
	<div class="tw-flex tw-gap-2">
		<div v-if="configs.brand == 'Linker'">
			<a
				href="https://www.linker.com.sa/blogs-arabic/click-to-whatsapp-ads-complete-guide"
				class="tw-flex tw-items-center tw-gap-2 tw-rounded-lg tw-border tw-border-blue-200 tw-bg-blue-50 tw-px-2.5 tw-py-2"
				target="_blank"
			>
				<AppImage src="/assets/v2/image/whatsapp/meta-logo.webp" width="22px" />
				<div class="tw-text-sm tw-font-medium tw-text-blue-800">
					{{ $t('whatsapp.createWhatsappAd') }}
				</div>
			</a>
		</div>
		<AppButton
			:label="$t('whatsapp.create-order')"
			startIcon="assets/v2/image/icons/plus.svg"
			@click="goToCreateOrder"
			v-feature-flag="{ feature: featureFlag.E_COMMERCE }"
		/>
	</div>
</template>

<script setup>
import AppImage from '@/v2/components/image.vue';
import { featureFlag } from '@/v2/entities/feature-flag';
import { configs } from '@/v2/system-configs';
import { abilities, useLimitationsStore } from '@/v2/modules/products/stores/limitations';

const limitationStore = useLimitationsStore();

const goToCreateOrder = async () => {
	limitationStore.checkLimitation(abilities.CreateOrder).then(() => {
		document.location.href = '/orders/create';
	});
};
</script>

<style lang="scss" scoped></style>
